import React, {useEffect, useState} from "react";
import {AddButton} from "../../../helpers/ButtonHelper";
import {saveData} from "../../../helpers/Api";
import {Modal} from "react-bootstrap";
import {useMutation} from "@apollo/client";
import PlateIngredientForm from "./PlateIngredientForm";
import {AddPlateIngredient, getPlateIngredients} from "./PlateQueries";

const AddPlateIngredientModal = ({
                                   plateIngredientIds,
                                   plateId,
                                   onClose,
                                   shouldOpen,
                                   showButton
                                 }) => {
  const [show, setShow] = useState(false);
  const [flash, setFlash] = useState({});
  const [gqlCall] = useMutation(AddPlateIngredient, { refetchQueries: [getPlateIngredients] })

  let plateIngredient = {
    plateId: plateId,
    ingredient: null,
    qty: 1,
    unit: null,
    qtyInfo: ''
  }

  const closeModal = () => {
    setFlash({})
    setShow(false);
    if (onClose) onClose();
    // resetForm();
  }
  const showModal = (e) => {
    e.preventDefault()
    setShow(true);
  }

  useEffect(() => {
    if (shouldOpen) {
      showModal(true)
    }
  }, [shouldOpen])

  const onSubmit = (event) => {
    event.preventDefault()
    saveData({
      event: event,
      gqlCall: gqlCall,
      query_key: 'addPlateIngredient',
      success: (res) => {
        closeModal()
      },
      flash_callback: setFlash
    })
  }

  return (
    <>
      {showButton && <AddButton to='#' onClick={showModal} />}

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Adauga un ingredient</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row justify-content-md-center">
              <PlateIngredientForm
                onSubmit={onSubmit}
                plateIngredient={plateIngredient}
                plateIngredientIds={plateIngredientIds}
                flash={flash} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default AddPlateIngredientModal;
